module.exports = __webpack_public_path__ + "static/media/spinner.0b965a38.gif";